import { styled } from '@mui/material';
import { lightPalette, up } from '../../../../../theme';

export const classes = {
  root: 'root',
  CloseAction: 'CloseAction',
  CardComponent: 'CardComponent',
  errorCardComponent: 'errorCardComponent',
  CardHeader: 'CardHeader',
  HeaderTypography: 'HeaderTypography',
  GridTypography: 'GridTypography',
  GridTextfield: 'GridTextfield',
  GridButton: 'GridButton',
  GridBoxButton: 'GridBoxButton',
  CardContent: 'CardContent',
  CardBox: 'CardBox',
  EyeIconForPassord: 'EyeIconForPassord',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.CloseAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.CardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '320px',
    },
    [up('sm')]: {
      width: '375px',
      height: '330px',
    },
    [up('md')]: {
      width: '420px',
      height: '345px',
    },
    [up('lg')]: {
      width: '500px',
      height: '340px',
    },
    [up('xl')]: {
      width: '575px',
      height: '410px',
    },
    [up('xxl')]: {
      width: '650px',
      height: '450px',
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '320px',
    },
    [up('sm')]: {
      width: '430px',
      height: '490px',
    },
    [up('md')]: {
      width: '500px',
      height: '490px',
    },
    [up('lg')]: {
      width: '500px',
      height: '470px',
    },
    [up('xl')]: {
      width: '575px',
      height: '530px',
    },
    [up('xxl')]: {
      width: '650px',
      height: '570px',
    },
  },
  [`& .${classes.CardHeader}`]: {
    width: '100%',
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '60px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '55px',
    },
    [up('xl')]: {
      height: '85px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.HeaderTypography}`]: {
    color: lightPalette.darkPurple.main,
  },
  [`& .${classes.GridTypography}`]: {
    height: '100%',
    display: 'flex',
    fontWeight: 600,
    color: lightPalette.darkPurple.main,
  },
  [`& .${classes.GridTextfield}`]: {
    borderColor: lightPalette.darkPurple.lighter,
    '& .MuiInputBase-input': {
      [up('xs')]: {},
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '13px',
      },
      [up('lg')]: {
        height: '17px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '34px',
      },
    },
  },
  [`& .${classes.GridButton}`]: {
    height: '32px',
    width: '150px',
  },
  [`& .${classes.GridBoxButton}`]: {
    width: '100%',
    marginTop: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  [`& .${classes.CardContent}`]: {
    [up('xs')]: {
      padding: '0 10px',
    },
    [up('sm')]: {
      padding: '0 16px',
    },
    [up('md')]: {
      padding: '0 21px',
    },
    [up('lg')]: {
      padding: '0 25px',
    },
    [up('xl')]: {
      padding: '0 30px',
    },
    [up('xxl')]: {
      padding: '0 34px',
    },
  },
  [`& .${classes.CardBox}`]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [up('xs')]: {
      marginTop: '25px',
    },
    [up('sm')]: {
      marginTop: '29px',
    },
    [up('md')]: {
      marginTop: '33px',
    },
    [up('lg')]: {
      marginTop: '25px',
    },
    [up('xl')]: {
      marginTop: '24px',
    },
    [up('xxl')]: {
      marginTop: '25px',
    },
  },
  [`& .${classes.EyeIconForPassord}`]: {
    filter: 'brightness(98%) contrast(60%) sepia(10%)',
    [up('xs')]: {
      height: '10px',
      width: '10px',
    },
    [up('sm')]: {
      height: '10px',
      width: '10px',
    },
    [up('md')]: {
      height: '12px',
      width: '12px',
    },
    [up('lg')]: {
      height: '14px',
      width: '14px',
    },
    [up('xl')]: {
      height: '16px',
      width: '16px',
    },
    [up('xxl')]: {
      height: '18px',
      width: '18px',
    },
  },
}));
